<!-- start banner Area -->
<section class="top-banner mb-4">
    <div class="top-banner-img" style="">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h1 style="padding: 30px 0px 0px 0px !important;"> Profil Recrutement </h1>
                    <p class="text-white link-nav"><a [routerLink]="['/accueil', 'candidat']"
                            style="color: #ff5a00 !important">Accueil</a> <span class="lnr lnr-arrow-right"></span>
                        <span> profilrecrutement </span>
                    </p>

                </div>
            </div>
        </div>
    </div>
</section>
<!-- End banner Area -->

<section class="service-area section-gap" id="service">
    <div class="container mb-5">
        <!-- Taux de remplissage (progress bar) -->
        <div class="col-md-12 mb-5">
            <div class="label-progress">Taux de remplissage de vos informations</div>
            <div class="progress">
                <div [ngClass]="{'progress-bar bg-danger text-white': totalFillingRate < 50, 'progress-bar bg-warning text-dark' : totalFillingRate < 100, 'progress-bar bg-success text-center text-white' : totalFillingRate === 100 }"
                    role="progressbar" [ngStyle]="{'width': totalFillingRate + '%', 'text-align': 'center'}"
                    aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">{{ totalFillingRate }}%</div>
            </div>
        </div>
        <section class="row justify-content-center">
            <!-- Button to go back apply job -->
            <div class="col-md-4" *ngIf="showBtnToGoApplyJob">
                <button routerLink="/postuler/{{ jobIDToApply }}" class="btn btn-warning">Retour vers la page
                    d'emploi</button>
            </div>

        </section>
        <!-- Profile recrutement -->
        <div class="col-md-6 mb-5">
            <fieldset class="form-area fieldset-panel">
                <legend class="legend-style" style="width: 50%;">Profil recrutement </legend>
                <form [formGroup]="profilesForm" (ngSubmit)="onSubmitProfileForm()">

                    <div class="row">
                        <div class="form-group col-md-6">
                            <label for="profession">Métier <span class="star-style">**</span></label>
                            <select class="form-control" id="profession" formControlName="profession_id">
                                <option value="">Selectionner...</option>
                                <option value="{{ profession.getId() }}" *ngFor="let profession of professionList">{{
                                    profession.getLibelle() }}</option>
                            </select>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="years_of_experience">Année d'expérience <span
                                    class="star-style">**</span></label>
                            <select class="form-control" id="years_of_experience" formControlName="years_of_experience">
                                <option value="">Selectionner...</option>
                                <option value="Sans experience">Sans experience</option>
                                <option value="Moins d'un an">Moins d'un an</option>
                                <option value="1 à 2ans">1 à 2ans</option>
                                <option value="3 à 5ans">3 à 5ans</option>
                                <option value="6 à 10ans">6 à 10ans</option>
                                <option value="10 à 15ans">10 à 15ans</option>
                                <option value="Plus de 15ans">Plus de 15ans</option>
                            </select>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="position_level">Niveau de profil <span class="star-style">**</span></label>
                            <select class="form-control" id="position_level" formControlName="position_level">
                                <option value="">Selectionner...</option>
                                <option value="Stagiaire/Etudiant">Stagiaire/Etudiant</option>
                                <option value="Jeune diplomé">Jeune diplomé</option>
                                <option value="Débutant/Junior">Débutant/Junior</option>
                                <option value="Confirmé/Experimenté">Confirmé/Experimenté</option>
                            </select>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="level_of_study">Diplôme <span class="star-style">**</span></label>
                            <select class="form-control" id="level_of_study" formControlName="level_of_study">
                                <option value="">Selectionner...</option>
                                <option value="Secondaire">Secondaire</option>
                                <option value="Terminal">Terminal</option>
                                <option value="Formation professionnelle">Formation professionnelle</option>
                                <option value="Baccalauréat">Baccalauréat</option>
                                <option value="Universitaire sans diplôme">Universitaire sans diplôme</option>
                                <option value="BAC + 2">BAC + 2</option>
                                <option value="Licence(BAC + 3)">Licence(BAC + 3)</option>
                                <option value="Master 1(BAC + 4)">Master 1(BAC + 4)</option>
                                <option value="Master 2(BAC + 5)">Master 2(BAC + 5)</option>
                                <option value="Doctorat(BAC + 7)">Doctorat(BAC + 7)</option>
                            </select>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="training">Formation <span class="star-style">**</span></label>
                            <select class="form-control" id="training" formControlName="training_id">
                                <option value="">Selectionner...</option>
                                <option value="{{ training.getId() }}" *ngFor="let training of trainingList">{{
                                    training.getLibelle() }}</option>
                            </select>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="availability">Disponibilité</label>
                            <select class="form-control" id="availability" formControlName="availability">
                                <option value="">Selectionner...</option>
                                <option value="Immédiate">Immédiate</option>
                                <option value="1mois">1 mois</option>
                                <option value="1 à 3mois">1 à 3mois</option>
                            </select>
                        </div>

                        <div class="form-group col-md-6">
                            <label for="mobility">Mobilité</label>
                            <select class="form-control" id="mobility" formControlName="mobility">
                                <option value="">Selectionner...</option>
                                <option value="Régionale">Régionale</option>
                                <option value="Nationale">Nationale</option>
                                <option value="Internationale">Internationale</option>
                            </select>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="status">Statut</label>
                            <select class="form-control" id="status" formControlName="status">
                                <option value="">Selectionner...</option>
                                <option value="En poste">En poste</option>
                                <option value="Sans emploi">Sans emploi</option>
                                <option value="En fin de contrat">En fin de contrat</option>
                            </select>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="current_salary">Salaire actuel <span>(1K = 1 000)</span></label>
                            <select class="form-control" id="current_salary" formControlName="current_salary">
                                <option value="">Selectionner...</option>
                                <option value="Moins de 100K">Moins de 100K (F CFA)</option>
                                <option value="100 à 200K">100 à 200K (F CFA)</option>
                                <option value="200 à 300K">200 à 300K (F CFA)</option>
                                <option value="300 à 400K">300 à 400K (F CFA)</option>
                                <option value="400 à 500K">400 à 500K (F CFA)</option>
                                <option value="Plus de 500K">Plus de 500K (F CFA)</option>
                            </select>
                        </div>


                        <div class="form-group col-md-6">
                            <label for="desired_salary">Salaire souhaité</label>
                            <select class="form-control" id="desired_salary" formControlName="desired_salary">
                                <option value="">Selectionner...</option>
                                <option value="Moins de 100K">Moins de 100K (F CFA)</option>
                                <option value="100 à 200K">100 à 200K (F CFA)</option>
                                <option value="200 à 300K">200 à 300K (F CFA)</option>
                                <option value="300 à 400K">300 à 400K (F CFA)</option>
                                <option value="400 à 500K">400 à 500K (F CFA)</option>
                                <option value="Plus de 500K">Plus de 500K (F CFA)</option>
                            </select>
                        </div>
                    </div>
                    <div class="row">
                        <button type="submit" class="primary-btn text-white" [disabled]="profilesForm.invalid"
                            *ngIf="!profileIsLoading">SAUVEGARDER</button>
                        <p class="text-danger" style="padding-top: 15px; margin-left: 15px;" *ngIf="profileIsLoading">
                            Veuillez patienter...</p>
                    </div>
                </form>
            </fieldset>
        </div>
    </div>
</section>